import * as React from 'react';
import { colorBackground, colorBrand, colorSubtle, colorWhite } from '../theme/color';
import { CSSProperties, NestedCSSProperties } from 'typestyle/lib/types';
import { em, important, px } from 'csx';
import { classes, style } from 'typestyle';
import { center, centerJustified, inlineRoot } from 'csstips';
import { transitionQuickEase } from '../theme/transition';

export interface PillProps {
  className?: string;
  style?: any;
  styles?: Array<NestedCSSProperties>;
  onClick?(event: React.MouseEvent<any>): void;
  contrast?: boolean;
}

export const PillStyle: CSSProperties = {
  ...inlineRoot,
  ...center,
  ...centerJustified,
  border: 0,
  flexShrink: 0,
  display: 'inline-flex',
  borderRadius: em(1.6),
  lineHeight: em(1.2),
  padding: '0.6em 1.4em',
  cursor: 'pointer',
  textDecoration: 'none',
  userSelect: 'none',
  fontSize: px(14),
  fontWeight: 600,
  appearance: important('none'),
  '-webkit-appearance': important('none'),
  '-moz-appearance': important('none'),
};

export const PillStyleDefault: NestedCSSProperties = {
  background: colorBrand.toString(),
  color: colorWhite.toString(),
  transition: `all ${transitionQuickEase}`,
  whiteSpace: 'pre',
  $nest: {
    '&:hover': {
      background: colorBrand.darken(0.15).toString()
    }
  }
};

export const PillStyleDisabled: NestedCSSProperties = {
  background: colorBackground.fade(0.7).toString(),
  color: colorSubtle.toString(),
  cursor: 'default'
};

const styles = {
  container: style(),
  containerDefault: style(),
  containerDisabled: style()
};

export const Pill: React.SFC<PillProps> = (props) => {
  const cz = classes(
    styles.container,
    !props.className && styles.containerDefault,
    props.styles && style(...props.styles),
    props.className
  );

  return (
    <div className={cz} onClick={props.onClick} style={props.style}>
      {props.children}
    </div>
  )
};